import type {Auth} from 'src/typings';
import type {AjaxService} from 'core/data-services/ajax.service';
import type {InternalLoginCredentials} from 'shared/login/kp-login/login-systems/internal/types';

export class LdapLoginSystemDataService {
    public static serviceName = 'ldapLoginSystemDataService'


    private static readonly LDAP_AUTH_ROUTE = '/auth/ldap';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }


    public sendRequest(credentials: InternalLoginCredentials): Promise<Auth> {
        return this.ajaxService
            .createRequest(LdapLoginSystemDataService.LDAP_AUTH_ROUTE)
            .post<Auth>(credentials);
    }
}